<template>
    <div class="col-md-10">
        <table class="table table-condensed table-hover" v-if="sizeItems.view === 2">
            <tbody>
                <tr v-for="(s, index3) in sizeItems.sizes" :key="'size' + index3">
                    <td width="60%">{{ s.name }}</td>
                    <td>
                        <input
                            type="text"
                            class="form-control c-platos"
                            placeholder="0"
                            v-model="s.price"
                        />
                    </td>
                    <td>
                        <i
                            class="fas fa-times"
                            v-if="sizeItems.sizes.length > 1"
                            @click="removeSize(p, index3)"
                        ></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <ul class="list-group" v-else>
            <li
                class="list-group-item"
                v-for="(s) in sizeItems.sizes"
                :key="'size' + s.id"
            >
                {{ s.name }}
                <span class="badge badge-pill badge-light float-right"
                    >${{ s.price | formatMoney }}</span
                >
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "menu_size",
    components: {},
    props: {
        sizeItems: { type: Object, required: true },
    },
    data () {
        return {
            isLoading: false,
        }
    },
    methods: {
        addSize(p, index) {
            let idNew = parseInt(p.size.length) + 1;
            p.size.push({
                id: idNew + "" + index,
                name: "",
                precio: 0,
                required: false,
            });
        },
        removeSize(p, index) {
            if (p.size.length > 1) {
                p.size.splice(index, 1);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.addSize {
    border: 1px solid;
    padding: 5px 8px;
    margin-right: 4px;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
    background-color: #585858;
    border-color: #585858;
    padding: 4px 6px;
    font-size: 0.7rem;
}
</style>
